// extracted by mini-css-extract-plugin
module.exports = {"root":"Widget_root__1lgDn","data":"Widget_data__3H0Cr","name":"Widget_name__RAIz8"};